var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.usage)?[_c('div',{staticClass:"qrcode",attrs:{"info":"二维码"}},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":_vm.src,"alt":"二维码"}})])])]:[_vm._m(0)]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usage_qr",attrs:{"info":"二维码"}},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":require("../assets/img/qr_mask.png"),"alt":"二维码"}})])])
}]

export { render, staticRenderFns }